import Service from '../../../../../services';
import { baseUrlAdmin } from '../../../../../store/apiConstants';

export class StudentAdmissionChangeRequestsService {
    constructor() {
        this.service = new Service();
    }

    async getChangeRequests(lazyParams, globalSearch, dropdownsData, searchLevel, searchType, searchValue) {
        const academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/statusChange/get/all/admissionrequests?academicYear=${academicYear}&limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        const payload = {
            sectionId: searchLevel === 1 ? dropdownsData?.sectionId : undefined,
            isUserNameSearch: searchLevel === 2 && searchType === 'studentName',
            username: searchValue,
            assignedHeirarchy: dropdownsData?.heirarchy,
            studentId: dropdownsData?.studentIds,
            branchIds: dropdownsData?.branchIds || [],
            boardId: dropdownsData?.boardIds || [],
            gradeId: dropdownsData?.classIds || [],
        };

        if (searchLevel === 1 && !dropdownsData?.sectionId) {
            payload.branchIds = dropdownsData?.branchIds || [];
        }
        if (searchLevel === 2 && !dropdownsData?.studentId) {
            payload.studentId = dropdownsData?.studentId || [];
        }

        try {
            const response = await this.service.post(url, payload, true);
            
            if (response?.status && response?.res?.status) {
                return {
                    success: true,
                    data: response.res?.data?.data,
                    totalRecords: response.res?.data?.totalRecords
                };
            } else {
                return {
                    success: false,
                    error: response.errMessage || 'Failed to fetch change requests'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'API Error occurred'
            };
        }
    }

    async updateAdmissionChange(rowData, approveStatus, dropdownsData, advanceAdjustmentType, isManualAdjustment) {
        const payload = {
            ...rowData,
            approveStatus,
            admissionChangeRequest: 'DONE',
            handledBy: rowData?.handledBy || [],
            levelAndBranchDetails: dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id === rowData?.user_info?.branchId),
            advanceAdjustment: {
                type: advanceAdjustmentType,
                isManual: isManualAdjustment
            }
        };

        const url = `${baseUrlAdmin}/statusChange/admission/update`;

        try {
            const response = await this.service.post(url, payload, true);
            
            if (response?.status && response?.res?.status) {
                return {
                    success: true,
                    message: response.errMessage
                };
            } else {
                return {
                    success: false,
                    error: response.errMessage || 'Failed to update admission change'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'API Error occurred'
            };
        }
    }

    async checkAdmissionChangeEligibility(selectedStudentData, effectiveDate) {
        const payload = {
            user_id: selectedStudentData.user_id,
            academicYear: selectedStudentData?.user_info?.academicYear,
            branchId: selectedStudentData?.user_info?.branchId,
            admissionCategory: selectedStudentData?.user_info?.admissionCategory,
            boardId: selectedStudentData?.user_info?.boardId,
            classId: selectedStudentData?.user_info?.classId,
            sectionId: selectedStudentData?.user_info?.sectionId,
            effectiveDate: effectiveDate
        };

        const url = `${baseUrlAdmin}/statusChange/addmission-change-check`;

        try {
            const response = await this.service.post(url, payload, true);
            
            if (response?.status) {
                return {
                    success: true,
                    data: response.res.data?.data,
                    message: response.res.data?.message
                };
            } else {
                return {
                    success: false,
                    error: response?.errMessage || 'Failed to check admission change eligibility'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'API Error occurred'
            };
        }
    }

    async getModifiedAmount(selectedStudentData, effectiveDate) {
        const payload = {
            user_id: selectedStudentData.user_id,
            academicYear: selectedStudentData?.user_info?.academicYear,
            branchId: selectedStudentData?.user_info?.branchId,
            admissionCategory: selectedStudentData?.user_info?.admissionCategory,
            boardId: selectedStudentData?.user_info?.boardId,
            classId: selectedStudentData?.user_info?.classId,
            sectionId: selectedStudentData?.user_info?.sectionId,
            effectiveDate: new Date(effectiveDate),
            newAdmissionCategory: selectedStudentData?.requestedAdmissionCat
        };

        const url = `${baseUrlAdmin}/statusChange/admission-change-fee`;

        try {
            const response = await this.service.post(url, payload, true);
            return {
                success: response?.res?.data?.status || false,
                data: response?.res?.data?.response,
                response: response
            };
        } catch (error) {
            return {
                success: false,
                error: error.message || 'API Error occurred'
            };
        }
    }

    async getFeeStructure(branchId) {
        const academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/fee-category?academicYear=${academicYear}&branchId=${branchId}`;

        try {
            const response = await this.service.get(url, true);
            
            if (response?.status && response?.res?.data?.response) {
                return {
                    success: true,
                    data: response.res.data.response
                };
            } else {
                return {
                    success: false,
                    error: 'Failed to fetch fee structure'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'API Error occurred'
            };
        }
    }

    async updateSchedulerByDate() {
        const url = `${baseUrlAdmin}/statusChange/update-by-date`;

        try {
            const response = await this.service.get(url, true);
            
            if (response?.status && response?.res?.status) {
                return {
                    success: true,
                    message: response.res?.data?.message || 'Admission status updated successfully'
                };
            } else {
                return {
                    success: false,
                    error: response.errMessage || 'Failed to update admission status'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'API Error occurred'
            };
        }
    }
}
